import {setClientCookie, getClientCookie} from './clientCookies';
import Cookies from 'js-cookie';

import {Buffer} from 'buffer'; // Ensure Buffer is available
const LegacyUnityConfigCookieName = 'i_uc_';
export const UnityConfigCookieName = 'i_ucc';
export const UnityInstanceStringCookieName = 'i_uic';

export type UnityConfig = {
  dataUrl: string;
  frameworkUrl: string;
  codeUrl: string;
  companyName: string;
  productName: string;
  productVersion: string;
};

export type SessionUnityConfig = UnityConfig & {gameId: string};

class FingerprintStore {
  private unityConfig: string | undefined;
  //private unityInstanceString: string | undefined;

  // Pass in as object to store the UnityConfig, which will be encoded and stored in a cookie
  // as a base64 string. However, fetching will not return the object, but the base64 string.

  setUnityConfig(config: UnityConfig, gameId: string) {
    console.debug('setUnityConfig', gameId, config);

    const configString = JSON.stringify({...config, gameId});
    const encodedConfig = Buffer.from(configString, 'utf-8').toString('base64');
    const cookieName = `${UnityConfigCookieName}_${gameId}`;
    this.clearLegacyUnityTokens();
    this.clearOldUnityTokens();
    // Set the new cookie with a timestamp in its value
    const timestamp = Date.now();
    setClientCookie(cookieName, `${encodedConfig}|${timestamp}`);
  }

  clearLegacyUnityTokens() {
    // This function clears all of the older legacy unity tokens to
    // make sure we start with a clean slate. Can be removed at a later date.
    const allCookies = Cookies.get();
    if (allCookies) {
      const unityConfigCookies = Object.keys(allCookies)
        .filter(
          (cookie) =>
            cookie.startsWith(LegacyUnityConfigCookieName) || cookie.startsWith('sklz_session_')
        )
        .map((cookie) => ({
          name: cookie,
          value: allCookies[cookie],
          timestamp: parseInt(allCookies[cookie]?.split('|').pop() || '0', 10), // Assuming timestamps are appended
        }));

      unityConfigCookies.forEach((cookie) => {
        if (cookie.name != 'sklz_session_base') {
          Cookies.remove(cookie.name, {path: '/'});
        }
      });
    }
  }

  clearOldUnityTokens() {
    // Get all cookies
    const allCookies = Cookies.get();

    // Filter cookies with the UnityConfig prefix
    if (allCookies) {
      const unityConfigCookies = Object.keys(allCookies)
        .filter((cookie) => cookie.startsWith(UnityConfigCookieName))
        .map((cookie) => ({
          name: cookie,
          value: allCookies[cookie],
          timestamp: parseInt(allCookies[cookie]?.split('|').pop() || '0', 10), // Assuming timestamps are appended
        }))
        .sort((a, b) => a.timestamp - b.timestamp); // Sort by timestamp (oldest first)

      // If there are more than 2 UnityConfig cookies, delete the older ones
      if (unityConfigCookies.length > 2) {
        unityConfigCookies.slice(0, -2).forEach((cookie) => {
          console.log('Deleting oldest UnityConfig cookie:', cookie.name);
          Cookies.remove(cookie.name, {path: '/'});
        });
      }
    }
  }

  getUnityConfigObject(gameId: string) {
    const config = this.getUnityConfig(gameId);
    if (!config) {
      return undefined;
    }
    const decodedConfig = Buffer.from(config, 'base64').toString('utf-8');
    const unityConfigObject = JSON.parse(decodedConfig); // Parse the JSON string
    return unityConfigObject;
  }

  getUnityConfig(gameId: string) {
    console.debug('getUnityConfig', gameId);

    if (!this.unityConfig) {
      const cookieName = `${UnityConfigCookieName}_${gameId}`;
      const configCookie = getClientCookie(cookieName); // Retrieve the cookie value on the client side

      if (configCookie) {
        // Remove the timestamp from the cookie value
        const [encodedConfig] = configCookie.split('|');
        this.unityConfig = encodedConfig;
      }
    }

    return this.unityConfig;
  }

  setUnityInstanceString(instance: string) {
    // This line does nothing to silence errors.
    instance = instance?.replace(/\\/g, '');
    return instance;
    // this.unityInstanceString = instance;
    // const encodedInstance = Buffer.from(instance, 'utf-8').toString('base64');
    // setClientCookie(UnityInstanceStringCookieName, encodedInstance);
  }

  getUnityInstanceString() {
    // if (!this.unityInstanceString) {
    //   const instanceCookie = getClientCookie(UnityInstanceStringCookieName); // Client-side cookies
    //   if (instanceCookie) {
    //     this.unityInstanceString = Buffer.from(instanceCookie, 'base64').toString('utf-8'); // Decode the Base64 string
    //   }
    // }
    // return this.unityInstanceString;
    return null;
  }
}

export const fingerprintStore = new FingerprintStore();
